<template>
  <div class="page">
    <Row>
      <Col
        style="text-align: center;margin-top: 200px;"
        :xs="{ span: 12, offset: 8 }"
        :lg="{ span: 8, offset: 8 }"
      >
        <h1 class="logo-text">{{projectName}}</h1>
        <a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备19019473号-2</a>
      </Col>
      <Col style="margin-top: 50px;" :xs="{ span: 12, offset: 8 }" :lg="{ span: 6, offset: 9 }">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <FormItem label prop="username">
            <Input
              class="has-prefix"
              :maxlength="50"
              v-model="formValidate.username"
              placeholder="请输入用户名"
            >
              <Icon type="md-contact" slot="prefix" />
            </Input>
          </FormItem>
          <FormItem label prop="password">
            <Input
              class="has-prefix"
              style="padding-left: 0px!important;"
              :type="'password'"
              :minlength="6"
              :maxlength="20"
              v-model="formValidate.password"
              placeholder="请输入登录密码"
            >
              <Icon type="md-lock" slot="prefix" />
            </Input>
          </FormItem>
          <FormItem>
            <Checkbox v-model="formValidate.autoLogin">自动登入寻灯页面</Checkbox>
            <Checkbox v-model="formValidate.rememberPassword" style="float: right">记住密码</Checkbox>
          </FormItem>
          <FormItem>
            <Button long type="success" @click="handleSubmit('formValidate')">登录</Button>
            <div style="text-align: center;margin-top: 10px;">
              <span
                style="color: seagreen;cursor: pointer;font-weight: bold;font-size: 14px;"
                @click="showModal"
              >许可证</span>
            </div>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Modal v-model="modal" title="许可证信息" @on-ok="ok" @on-cancel="cancel">
      <span style="width: 50px;margin-right: 20px;">许可证</span>
      <i-input v-model="permissionCard" style="width: 400px;" placeholder="请输入"></i-input>
    </Modal>
  </div>
</template>
<script>
const md5 = require("js-md5");
const LOGIN_URL = "/api/managerExtends/login";
import { post } from "@/libs/http/request";
import bus from "../bus";
export default {
  name: "Login",
  data() {
    return {
      projectName: "線上點燈",
    modal: false,
      permissionCard: "",
      formValidate: {
        username: "",
        password: "",
        autoLogin: false,
        rememberPassword: false
      },
      ruleValidate: {
        username: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "登录密码不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    showModal() {
      this.modal = true;
    },
    ok() {
      post(
        "/api/dataSync/syncTemple",
        { licence: this.permissionCard },
        res => {
          this.$Message.success("许可证填写成功！");
        }
      );
    },
    cancel() {
      this.$Message.info("取消填写许可证");
    },
    handleSubmit(name) {
      let that = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (that.formValidate.rememberPassword === true) {
            that.setCookie(
              that.formValidate.username,
              that.formValidate.password,
              that.formValidate.rememberPassword,
              that.formValidate.autoLogin,
              7
            );
          } else {
            that.clearCookie();
          }
          let param = {
            username: that.formValidate.username,
            // password:  md5(that.formValidate.password),
            password: that.formValidate.password
          };
          post(LOGIN_URL, param, res => {
            if (res != false) {
              let user = res;
              let menusList = res.menus;
              window.localStorage.setItem(
                "menusList",
                JSON.stringify(menusList)
              );
              localStorage.setItem("managerId", res.id);
              localStorage.setItem("token", res.token);
              window.localStorage.password = that.formValidate.password;
              window.localStorage.setItem("userData", JSON.stringify(user));
              bus.$emit("USER_DATA", user);
              that.$store.commit("SAVE_USER", {
                user: user
              });
              that.$store.dispatch("SAVE_USER_CACHE");
              if (that.formValidate.autoLogin === true) {
                that.$router.push("/seekLamp/list");
              } else {
                that.$router.push("/home");
              }
            } else {
              return false;
            }
          });
        }
      });
    },
    //初始化先获得cookie,记住密码设置cookie,取消则清空
    //1设置cookie
    setCookie(c_name, c_pwd, c_rmb, c_auto, exdays) {
      let exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "rmbNum" + "=" + c_rmb + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "autoLogin" + "=" + c_auto + ";path=/;expires=" + exdate.toGMTString();
    },
    //2读取cookie
    getCookie: function() {
      console.log(document.cookie)
      if (document.cookie.length > 0) {
        let arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (let i = 0; i < arr.length; i++) {
          let arr2 = arr[i].split("="); //再次切割

          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.formValidate.username = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.formValidate.password = arr2[1];
          } else if (arr2[0] == "rmbNum") {
            if (arr2[1] === "true") {
              let data = true;
              this.formValidate.rememberPassword = data;
            } else {
              let data = false;
              this.formValidate.rememberPassword = data;
            }
          } else if (arr2[0] == "autoLogin") {
            if (arr2[1] === "true") {
              let data = true;
              this.formValidate.autoLogin = data;
              this.formValidate.rememberPassword = true;
              this.$root.$on("deleteAutoLogin", param => {
                this.formValidate.autoLogin = false;
                return;
              });
              this.handleSubmit("formValidate");
            } else {
              let data = false;
              this.formValidate.autoLogin = data;
            }
          }
        }
      }
    },
    //3清除cookie
    clearCookie: function() {
      this.setCookie("", "", "", "", -1); //修改2值都为空，天数为负1天就好了
    },
    regainCaptcha() {
      let timestamp = new Date().valueOf();
      let url = this.$refs.captcha.src;
      if (url.indexOf("?") >= 0) {
        url = url.substring(0, url.length - 13) + timestamp;
      } else {
        url = url + "?timestamp=" + timestamp;
      }
      this.$refs.captcha.src = url;
    }
  },
  mounted() {
    this.getCookie();
  }
};
</script>
<style lang="less" scoped>
.page {
  background: url("../assets/login_bg.png");
  /*background-color: #ffffff;*/
  img.logo {
    width: 100px;
    height: 100px;
  }
  .logo-text {
    font-size: 30px;
    color: #333333;
  }
}
.loginBody {
  width: 480px;
  height: 448px;
  background: rgba(246, 249, 249, 1);
  border: 1px solid rgba(202, 129, 68, 1);
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue